<div class="border border-outline dark:border-outline-darkmode rounded-lg overflow-hidden">
  <app-supplier-contract-check-item-form-field
    [organizationId]="organizationId()"
    (fieldValueChange)="onChangeItem('CHECK_OVERALL_COST', $event)"
    [formField]="form.CHECK_OVERALL_COST"
  >
    <ng-icon slot="icon" name="heroDocumentCurrencyEuro" size="24" class="!block" />
    <h3 slot="title">{{ 'cockpit.supplierContracts.check.overallCost.title' | transloco }}</h3>
    <app-field-errors
      slot="error"
      [fieldState]="form.CHECK_OVERALL_COST.result()"
      class="empty:hidden text-sm"
    />
  </app-supplier-contract-check-item-form-field>
  <app-supplier-contract-check-item-form-field
    [organizationId]="organizationId()"
    (fieldValueChange)="onChangeItem('CHECK_PRICE_CONSUMPTION_MATCH', $event)"
    [formField]="form.CHECK_PRICE_CONSUMPTION_MATCH"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <ng-icon slot="icon" name="heroChartBarSquare" size="24" class="!block" />
    <h3 slot="title">
      {{ 'cockpit.supplierContracts.check.priceConsumptionMatch.title' | transloco }}
    </h3>
    <app-field-errors
      slot="error"
      [fieldState]="form.CHECK_PRICE_CONSUMPTION_MATCH.result()"
      class="empty:hidden text-sm"
    />
  </app-supplier-contract-check-item-form-field>
  <app-supplier-contract-check-item-form-field
    [organizationId]="organizationId()"
    (fieldValueChange)="onChangeItem('CHECK_FIX_COST', $event)"
    [formField]="form.CHECK_FIX_COST"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <ng-icon slot="icon" name="heroWallet" size="24" class="!block" />
    <h3 slot="title">{{ 'cockpit.supplierContracts.check.fixCost.title' | transloco }}</h3>
    <app-field-errors
      slot="error"
      [fieldState]="form.CHECK_FIX_COST.result()"
      class="empty:hidden text-sm"
    />
  </app-supplier-contract-check-item-form-field>
  <app-supplier-contract-check-item-form-field
    [organizationId]="organizationId()"
    (fieldValueChange)="onChangeItem('CHECK_INDEX_PRICE_DEPENDENCY', $event)"
    [formField]="form.CHECK_INDEX_PRICE_DEPENDENCY"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <ng-icon slot="icon" name="heroPresentationChartLine" size="24" class="!block" />
    <h3 slot="title">
      {{ 'cockpit.supplierContracts.check.indexPriceDependency.title' | transloco }}
    </h3>
    <app-field-errors
      slot="error"
      [fieldState]="form.CHECK_INDEX_PRICE_DEPENDENCY.result()"
      class="empty:hidden text-sm"
    />
  </app-supplier-contract-check-item-form-field>
  <app-supplier-contract-check-item-form-field
    [organizationId]="organizationId()"
    (fieldValueChange)="onChangeItem('CHECK_TRANCHE_TIMING_PERFORMANCE', $event)"
    [formField]="form.CHECK_TRANCHE_TIMING_PERFORMANCE"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <ng-icon slot="icon" name="heroClock" size="24" class="!block" />
    <h3 slot="title">
      {{ 'cockpit.supplierContracts.check.trancheTimingPerformance.title' | transloco }}
    </h3>
    <app-field-errors
      slot="error"
      [fieldState]="form.CHECK_TRANCHE_TIMING_PERFORMANCE.result()"
      class="empty:hidden text-sm"
    />
  </app-supplier-contract-check-item-form-field>
  <app-supplier-contract-check-item-form-field
    [organizationId]="organizationId()"
    (fieldValueChange)="onChangeItem('CHECK_CONSUMPTION_FLEXIBILITY', $event)"
    [formField]="form.CHECK_CONSUMPTION_FLEXIBILITY"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <ng-icon slot="icon" name="heroArrowsPointingOut" size="24" class="!block" />
    <h3 slot="title">
      {{ 'cockpit.supplierContracts.check.consumptionFlexibility.title' | transloco }}
    </h3>
    <app-field-errors
      slot="error"
      [fieldState]="form.CHECK_CONSUMPTION_FLEXIBILITY.result()"
      class="empty:hidden text-sm"
    />
  </app-supplier-contract-check-item-form-field>
  <app-supplier-contract-check-item-form-field
    [organizationId]="organizationId()"
    (fieldValueChange)="onChangeItem('CHECK_MARGIN_TRANSPARENCY', $event)"
    [formField]="form.CHECK_MARGIN_TRANSPARENCY"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <ng-icon slot="icon" name="heroEye" size="24" class="!block" />
    <h3 slot="title">
      {{ 'cockpit.supplierContracts.check.marginTransparency.title' | transloco }}
    </h3>
    <app-field-errors
      slot="error"
      [fieldState]="form.CHECK_MARGIN_TRANSPARENCY.result()"
      class="empty:hidden text-sm"
    />
  </app-supplier-contract-check-item-form-field>
  <app-supplier-contract-check-item-form-field
    [organizationId]="organizationId()"
    (fieldValueChange)="onChangeItem('CHECK_PRICING_BILLING_COMPLEXITY', $event)"
    [formField]="form.CHECK_PRICING_BILLING_COMPLEXITY"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <ng-icon slot="icon" name="heroBanknotes" size="24" class="!block" />
    <h3 slot="title">
      {{ 'cockpit.supplierContracts.check.pricingBillingComplexity.title' | transloco }}
    </h3>
    <app-field-errors
      slot="error"
      [fieldState]="form.CHECK_PRICING_BILLING_COMPLEXITY.result()"
      class="empty:hidden text-sm"
    />
  </app-supplier-contract-check-item-form-field>
  <app-supplier-contract-check-item-form-field
    [organizationId]="organizationId()"
    (fieldValueChange)="onChangeItem('CHECK_FIX_PRICE_GUARANTEE', $event)"
    [formField]="form.CHECK_FIX_PRICE_GUARANTEE"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <ng-icon slot="icon" name="heroLockClosed" size="24" class="!block" />
    <h3 slot="title">
      {{ 'cockpit.supplierContracts.check.fixPriceGuarantee.title' | transloco }}
    </h3>
    <app-field-errors
      slot="error"
      [fieldState]="form.CHECK_FIX_PRICE_GUARANTEE.result()"
      class="empty:hidden text-sm"
    />
  </app-supplier-contract-check-item-form-field>
  <app-supplier-contract-check-item-form-field
    [organizationId]="organizationId()"
    (fieldValueChange)="onChangeItem('CHECK_DECISION_MAKING_EFFORT', $event)"
    [formField]="form.CHECK_DECISION_MAKING_EFFORT"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <ng-icon slot="icon" name="heroArrowTrendingUp" size="24" class="!block" />
    <h3 slot="title">
      {{ 'cockpit.supplierContracts.check.decisionMakingEffort.title' | transloco }}
    </h3>
    <app-field-errors
      slot="error"
      [fieldState]="form.CHECK_DECISION_MAKING_EFFORT.result()"
      class="empty:hidden text-sm"
    />
  </app-supplier-contract-check-item-form-field>
  <app-supplier-contract-check-item-form-field
    [organizationId]="organizationId()"
    (fieldValueChange)="onChangeItem('CHECK_CONTRACT_FLEXIBILITY', $event)"
    [formField]="form.CHECK_CONTRACT_FLEXIBILITY"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <ng-icon slot="icon" name="heroPuzzlePiece" size="24" class="!block" />
    <h3 slot="title">
      {{ 'cockpit.supplierContracts.check.contractFlexibility.title' | transloco }}
    </h3>
    <app-field-errors
      slot="error"
      [fieldState]="form.CHECK_CONTRACT_FLEXIBILITY.result()"
      class="empty:hidden text-sm"
    />
  </app-supplier-contract-check-item-form-field>
</div>
